module.exports = __webpack_public_path__ + "static/media/990290.c8a50d0f.png";